import React, { useState, useRef } from "react";

const ACCEPT = ".pdf,.docx,.txt,.csv,.xlsx";

export default function UploadZone({ file, onFile }) {
  const [drag, setDrag] = useState(false);
  const inputRef = useRef(null);

  const accept = (f) => {
    if (!f) return;
    onFile({ name: f.name, sizeKB: Math.max(1, Math.round(f.size / 1024)) });
  };

  return (
    <div
      className={`lcx-upload ${drag ? "drag" : ""} ${file ? "loaded" : ""}`}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); accept(e.dataTransfer.files?.[0]); }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") inputRef.current?.click(); }}
    >
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        style={{ display: "none" }}
        onChange={(e) => accept(e.target.files?.[0])}
      />
      {file ? (
        <>
          <div className="u-icon">✅</div>
          <div className="u-title">{file.name} · Ready for AI processing</div>
          <div className="u-sub">{file.sizeKB} KB</div>
        </>
      ) : (
        <>
          <div className="u-icon">📎</div>
          <div className="u-title">Drop a CAPA report, risk assessment, SOP, or deviation log</div>
          <div className="u-sub">Supports PDF, DOCX, TXT, CSV — or click Run Demo to simulate without a file</div>
        </>
      )}
    </div>
  );
}